import { createReducer } from '@reduxjs/toolkit'
import { AccountProfileT } from 'shared/types/model'
import { receiveAccountProfile, clear, logout } from 'model/actions'

const initialState = null as AccountProfileT | null

const reducer = createReducer(initialState, builder => {
  builder
    .addCase(receiveAccountProfile, (state, action) => action.payload)
    .addCase(clear, () => initialState)
    .addCase(logout, () => initialState)
})

export default reducer
